// common — en. Part of the en i18n bundle; merged by ./index.js

export default {
// Navbar
  home: 'Home',
  about: 'About',
  contact: 'Contact',
  signIn: 'Sign In',
  signOut: 'Sign Out',
  myDashboard: 'My Dashboard',
  team: 'Team',
  linksWebsite: 'Website',
  allCities: '📍 All Cities',
  clearFilter: '✕ Clear',
  noClientsInCity: (city) => `No customers found in ${city}.`,
  verifiedBusinesses: 'Verified licensed businesses we promote',
  verified: '✓ Verified',
  noClients: 'No customers yet.',
  aboutSub: 'We are',
  vision: 'Vision',
  mission: 'Mission',
  visionText: "To become Ethiopia's leading digital marketing and e-commerce solutions company dedicated to empowering MSMEs — All Things by All Things Solution.",
  missionText: 'To deliver innovative, affordable and measurable marketing and advertising solutions that help Ethiopian MSMEs grow sustainably.',
  so1: 'Provide nationwide access to professional marketing services',
  so2: 'Support MSMEs growth through digital visibility and branding',
  so3: 'Utilize technology (website, mobile app, and social media) for service delivery',
  so4: 'Build long-term partnerships with MSMEs and institutions',
  so5: 'Create employment opportunities for skilled youth',
// Contact,
  contactTitle: 'Contact Us',
  contactSub: 'Ready to grow your business?',
  message: 'Message',
  successTitle: 'Message Sent!',
  successMsg: 'Thank you! We will contact you soon.',
  sendAnother: 'Send Another',
  selectType: 'Select type...',
  passwordPlaceholder: 'Password *',
  confirmPassword: 'Confirm Password *',
  minPassword: 'Min. 6 characters',
  alreadyHave: 'Already have an account?',
  businessDocsTitle: 'Business Documents',
  registrationFailed: 'Registration failed.',
// Login,
  loginTitle: 'Sign in to your account',
  loginBtn: 'Sign In',
  loggingIn: 'Signing in...',
  noAccount: "Don't have an account?",
  registerBusiness: 'Register your business',
  loginFailed: 'Login failed.',
// Navbar extras,
  blogsNews: 'Blogs/News',
  faq: 'FAQ',
  faqSubtitle: 'Everything you need to know about All Things, the Bazaar, and our services.',
  faq1q: 'What is All Things?',
  faq1a: 'All Things is a digital marketing agency and e-commerce platform based in Addis Ababa, Ethiopia. We help licensed Ethiopian businesses grow online through marketing services and our Bazaar marketplace.',
  faq2q: 'How do I register as a seller?',
  faq2a: 'Go to our Contact page and fill in the registration form with your business details, including your TIN number, business license, and Elmis registration. Our team will review your application and activate your account.',
  faq3q: 'How do I buy from the Bazaar?',
  faq3a: 'Browse products in the Bazaar, add items to your wishlist, and proceed to checkout. You\'ll need to register as a buyer first. Payment is handled directly between you and the seller.',
  faq4q: 'What payment methods are accepted?',
  faq4a: 'Payment methods vary by seller. Many accept bank transfer, mobile money, or cash on delivery within Addis Ababa. Check the product page for seller-specific payment options.',
  faq5q: 'How does delivery work?',
  faq5a: 'Delivery arrangements are made directly with the seller after purchase. Many sellers offer delivery within Addis Ababa. You can discuss delivery options with your seller via our chat feature.',
  faq6q: 'Is there a return policy?',
  faq6a: 'Returns are handled between you and the seller. We recommend messaging the seller through our platform before purchasing to confirm their return policy.',
  faq7q: 'How do I become a digital marketing client/customer?',
  faq7a: 'Contact us through our Contact page or email allthingsethiopia2026@gmail.com. We\'ll discuss your business needs and create a custom marketing plan.',
  faq8q: 'What services does All Things offer?',
  faq8a: 'We offer digital marketing, social media management, website development, branding, content creation, and e-commerce solutions for Ethiopian businesses.',
// About extras,
  aboutTag: 'About Us',
  aboutHeroTitle1: 'Empowering Ethiopia\'s',
  aboutHeroTitle2: 'Digital Future',
  aboutCatalyst: 'We are the catalyst for Ethiopian MSMEs growth in the modern digital marketplace.',
  whoWeAre: 'Who We Are',
  whoWeAreText: 'We are a digital marketing and e-commerce support platform helping Ethiopian MSMEs transition from traditional business methods to modern, technology-driven growth. Our mission is to bridge the gap between local quality and global visibility.',
  ourCoreValues: 'Our Core',
  ourCoreValuesHighlight: 'Values',
  strategic: 'Strategic',
  strategicHighlight: 'Objectives',
// Register extras,
  joinAllThings: 'Join All',
  joinAllThingsHighlight: 'Things',
  chooseAccountType: 'Choose your account type to get started',
  registerYourBusiness: 'Register your licensed business for professional promotion services.',
  haveAccount: 'Already have an account?',
  registrationSubmitted: 'Registration Submitted!',
  thankYouName: (name) => `Thank you, ${name}!`,
  thankYouRegistering: 'Your account is currently under review. Our team will verify your business within 48 hours.',
  goToLogin: 'Go to Login',
  selectCity: 'Select city...',
// Login extras,
  forgot: 'Forgot?',
// Contact info card labels,
  labelEmail: 'Email',
  labelLocation: 'Location',
  labelPhone: 'Phone',
  labelHours: 'Hours',
  labelTelegram: 'Telegram',
  labelWhatsApp: 'WhatsApp',
  messages: '💬 Messages',
  noConversations: 'No conversations yet.',
  selectConversation: 'Select a conversation to start chatting',
  typeMessage: 'Type a message...',
  new: 'new',
// Dashboard,
  changePassword: 'Change Password',
  copyright: '© 2026 All Things Solution PLC',
// Client detail,
  backToClients: 'Back to Customers',
  established: 'Established',
  location: 'Location',
  verifiedLicensed: 'Verified Licensed Business',
  licenseLabel: 'License',
  clientWorkTitle: 'Their Work',
  ourMarketingWork: 'Our Marketing Work',
  contactSocial: 'Contact & Social Media',
// Core values,
  cv1Title: 'Innovation and Creativity',
  cv1Desc: 'We embrace new ideas and creative solutions',
  cv2Title: 'Customer-Centered Service',
  cv2Desc: "Our customers' success is at the heart of everything we do",
  cv3Title: 'Integrity and Transparency',
  cv3Desc: 'We operate with honesty and openness',
  cv4Title: 'Technology Adoption',
  cv4Desc: 'We leverage the latest digital tools',
  cv5Title: 'Results-Oriented Performance',
  cv5Desc: 'We focus on measurable outcomes',
// Team,
  teamOurPeople: 'Our People',
  teamTitle: 'Meet the',
  teamTitleHighlight: 'Team',
  teamSubtitle: 'The talented people behind All Things Solution',
// Bazaar,
  filters: 'Filters',
  priceRangeEtb: 'Price Range (ETB)',
  anyPrice: 'Any Price',
  reopensAt: (x) => `Reopens at ${x}`,
  days: 'Days',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  allClientsLabel: 'Customers',
  legalTitle: 'Legal / Policies',
  legalTerms: 'Terms & Conditions',
  legalPrivacy: 'Privacy Policy',
  legalBilling: 'Billing Policy',
  legalCookie: 'Cookie Policy',
  legalCopyright: 'Copyright Policy',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  cartTitle: 'Your Wishlist',
  checkoutTitle: 'Checkout',
  deliveryTitle: 'Request Delivery',
  addToCart: 'Add to Wishlist',
  added: 'Added',
  proceedToCheckout: 'Proceed to Checkout',
  placeOrder: 'Place Order',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  outOfStock: 'Out of Stock',
  selectBank: 'Select Payment Method',
  uploadScreenshot: 'Upload Screenshot',
  enterReference: 'Enter Reference Number',
  cartTotal: 'Total',
  linkedOrder: 'Select Order',
  deliveryAddress: 'Delivery Address',
  contactPhone: 'Contact Phone',
  preferredTime: 'Preferred Delivery Time',
  outOfStockError: 'Some items in your wishlist are out of stock.',
  deliveryDuplicateError: 'A delivery request already exists for this order.',
  backToBazaar: 'Back to Bazaar',
  allCategories: 'All Categories',
  noOrders: 'No orders yet.',
// Buyer account,
  registerAsSeller: 'Register as Seller',
  registerAsBuyer: 'Register as Buyer',
  buyerRegisterTitle: 'Create your buyer account',
  buyerDashboardTitle: 'My Purchase History',
  groupedByCategory: 'By Category',
  groupedBySeller: 'By Seller',
  noPurchases: 'No purchases yet.',
  instantlyActive: 'Your account is active!',
  ourRoots: 'Our Roots',
  bridgingTitle: 'Bridging Tradition &',
  bridgingHighlight: 'Innovation',
  rootsText: 'We empower Ethiopian MSMEs to thrive in the global digital landscape while staying true to our rich heritage. From local markets to digital storefronts, we are your partner in growth.',
  ourStory: 'Our Story',
  servicesBoost: 'Services We Provide To Boost Your Business',
  appStore: 'App Store',
  googlePlay: 'Google Play',
// Service cards,
  svcSocialMedia: 'Social Media Management',
  svcSocialMediaDesc: 'Complete management of your social media accounts with consistent posting, audience engagement, and content strategy.',
  svcContentCreation: 'Content Creation',
  svcContentDesc: 'Professional photos, videos, and graphics that tell your brand story and captivate your target audience.',
  svcGrowthStrategy: 'Growth Strategy',
  svcGrowthDesc: 'Data-driven strategies designed to accelerate your business growth and expand market reach.',
  svcPaidAds: 'Paid Advertising',
  svcAdsDesc: 'Targeted advertising campaigns across all platforms to maximize ROI and reach the right customers.',
  svcBranding: 'Branding & Logo Design',
  svcBrandingDesc: 'Memorable brand identity, logo creation, and visual storytelling that sets you apart from competitors.',
  svcOutdoor: 'Outdoor Advertising',
  svcOutdoorDesc: 'Billboards, banners, and offline visibility solutions to complement your digital marketing efforts.',
  svcEcommerce: 'E-Commerce Setup',
  svcEcomDesc: 'Complete online store setup, product listing, and marketplace integration on the All Things Bazaar.',
  svcConsultation: 'Business Consultation',
  svcConsultDesc: 'Expert guidance and strategic advice to help your business navigate the digital landscape effectively.',
// Clients extras,
  ourPartners: 'Our',
  ourPartnersHighlight: 'Partners',
  partnersDesc: 'Meet the innovative Ethiopian businesses scaling their digital presence with All Things.',
  category: 'Category',
  allCategoriesLabel: 'All Categories',
  city: 'City',
// Team extras,
  viewProfile: 'View Profile',
  mpHeroTitle: 'Marketplace for',
  mpHeroTitleHighlight: 'Verified Businesses',
  mpHeroDesc: 'Discover trusted Ethiopian businesses, shop quality products, and grow your brand on Africa\'s rising digital marketplace.',
  mpStartShopping: 'Start Shopping',
  mpRegisterBusiness: 'Register Your Business',
  mpStatBusinesses: 'Verified Businesses',
  mpStatProducts: 'Products Listed',
  mpStatCities: 'Cities Covered',
  mpStatSatisfaction: 'Customer Satisfaction',
  mpTrustVerified: 'Verified Businesses',
  mpTrustSecure: 'Secure Payments',
  mpTrustReturns: 'Easy Returns',
  mpTrust247: '24/7 Support',
  mpTrustVerifiedDesc: 'All businesses are licensed and verified',
  mpTrustSecureDesc: 'Protected transactions every step',
  mpTrustReturnsDesc: 'Hassle-free return policy',
  mpTrust247Desc: 'We are here to help anytime',
  mpCatTitle: 'Shop by',
  mpCatTitleHighlight: 'Category',
  mpCatDesc: 'Browse thousands of products across popular categories',
  mpPaymentsTitle: 'Secure Payment',
  mpPaymentsTitleHighlight: 'Methods',
  mpPaymentsDesc: 'Multiple secure payment options for your convenience',
  mpTestimonialTitle: 'What Our',
  mpTestimonialTitleHighlight: 'Sellers Say',
  mpTestimonialDesc: 'Hear from businesses thriving on All Things',
  mpNewsletterTitle: 'Stay Updated',
  mpNewsletterDesc: 'Subscribe to get the latest deals, new products, and marketplace news delivered to your inbox.',
  mpNewsletterPlaceholder: 'Enter your email',
  mpNewsletterBtn: 'Subscribe',
  mpNewsletterSuccess: '✓ Thank you for subscribing!',
  mpFooterQuickLinks: 'Quick Links',
};

